@if (infoSteps().length) {
  <div class="mb-5 mb-lg-6">
    <mwe-basic-card data-test="mwe-internet-status-steps">
      <mwe-next-steps [infoSteps]="infoSteps()" stepsTitle="newClient.status.steps.title" />
    </mwe-basic-card>
  </div>
}

<div class="mb-4">
  <mwe-address [address]="address()" [isAddressDetailsBodyVisible]="true" [isArrowDownHidden]="false" />
</div>

@if (nonFernwaermeProducts()?.length) {
  <div class="mb-4" data-test="products-summary-internet-container">
    <mwe-headline
      [headlineLevelIncrement]="0"
      [text]="registerStromGasTitle()"
      cssClass="mt-6"
      data-test="summary-register-internet-title"
    />
    @if (selectedTariffs()?.length > 0) {
      @if (isSummaryProductsFromWevTitleVisible()) {
        <mwe-headline
          [headlineLevelIncrement]="1"
          cssClass="h4 mt-6"
          text="summary.productsFromWEV"
          data-test="summary-products-from-wev"
        />
      }
      <div class="row mt-3 mb-0 gap-5 gap-md-6" data-test="products-summary-internet-products">
        <mwe-tariff-selection-container
          [selectedTariffs]="selectedTariffs()"
          [isReadOnly]="true"
          [headlineReference]="headlineService.getHeadline(1)"
          [isInternet]="true"
          cardCategoryTitleKeyPrefix="tariff.selectionCard.{{ selectedCategory() | lowercase }}"
          [tariffSheetUrls]="getTariffSheetUrls()"
        />
      </div>
    } @else {
      <div class="row mt-3 mb-0" data-test="products-summary-internet-products">
        @for (product of nonFernwaermeProducts(); track product) {
          <div class="col-12 col-lg-6 mb-4">
            <mwe-basic-card>
              <mwe-wizard-product-card
                [product]="product"
                [showTariffDetailsLink]="showTariffDetailsLink()"
                [showTariffDetails]="showStromGasTarifDetails() && showTariffDetails()"
                [isAvailable]="true"
                [tariffClasses]="product.tariffClasses"
                [tarifKey]="product.tarifKey"
                [productSelection]="productSelection()"
                [grundpreisLabelOverwrite]="grundpreisLabelOverwrite()"
                [attr.data-test]="'products-summary-card-' + product.category?.toLowerCase()"
              />
            </mwe-basic-card>
          </div>
        }
      </div>
    }
  </div>
}

@if (isNewInternetOrder()) {
  <div class="mb-lg-6 mb-5">
    <h2 class="mt-lg-6 mt-5 mb-4">{{ 'summary.internet.costOverviewTitle' | translate }}</h2>
    <mwe-basic-card
      [cardTitle]="'summary.internet.costOverviewOnce'"
      [iconClass]="'fa-coins'"
      [cardClass]="'mb-4'"
      [hasBackground]="true"
      data-test="internet-summary-cost-overview-once"
      headingNodeType="h3"
    >
      <mwe-infobox type="success" messageKey="summary.internet.costOverviewNoCost" iconClassOverwrite="fas fa-gift" />
    </mwe-basic-card>
    <mwe-basic-card
      [cardTitle]="'summary.internet.costOverviewMonthlyUntil'"
      [iconClass]="'fa-coins'"
      [cardClass]="'mb-4'"
      [hasBackground]="true"
      data-test="internet-summary-cost-overview-monthly-until"
      headingNodeType="h5"
    >
      <table class="table">
        <tbody>
          <tr>
            <td>{{ tariffName() }}</td>
            <td>{{ tariffCostReduced() }} {{ preisUnit() }}</td>
          </tr>
          @if (selectedTariff()?.userSelection?.length) {
            <tr>
              <td>{{ tvOptionName() }}</td>
              <td>{{ tvOptionCostReduced() }} {{ preisUnit() }}</td>
            </tr>
          }
          <tr>
            <td class="fw-bold text-secondary" translate="summary.internet.totalCost"></td>
            <td class="fw-bold text-secondary">{{ totalCostReduced() }} {{ preisUnit() }}</td>
          </tr>
        </tbody>
      </table>
      <p class="text--legal mb-0">{{ 'summary.internet.inklTax' | translate }}</p>
    </mwe-basic-card>
    <mwe-basic-card
      [cardTitle]="'summary.internet.costOverviewMonthlyFrom'"
      [iconClass]="'fa-coins'"
      [cardClass]="'mb-4'"
      [hasBackground]="true"
      data-test="internet-summary-cost-overview-monthly-from"
      headingNodeType="h3"
    >
      <table class="table">
        <tbody>
          <tr>
            <td>{{ tariffName() }}</td>
            <td>{{ tariffCost() }} {{ preisUnit() }}</td>
          </tr>
          @if (selectedTariff()?.userSelection?.length) {
            <tr>
              <td>{{ tvOptionName() }}</td>
              <td>{{ tvOptionCost() }} {{ preisUnit() }}</td>
            </tr>
          }
          <tr>
            <td class="fw-bold text-secondary">{{ 'summary.internet.totalCost' | translate }}</td>
            <td class="fw-bold text-secondary">{{ totalCost() }} {{ preisUnit() }}</td>
          </tr>
        </tbody>
      </table>
      <p class="text--legal mb-0">{{ 'summary.internet.inklTaxFull' | translate: { fullPrice: overallTotalCost() } }}</p>
    </mwe-basic-card>
  </div>
}
<div class="mb-lg-6 mb-5">
  <h2 class="mt-lg-6 mt-5 mb-4" translate="summary.yourContractDetails"></h2>
  <mwe-basic-card
    [cardTitle]="'summary.personalCustomerData'"
    [iconClass]="'fa-file-user'"
    [cardClass]="'mb-4'"
    [hasBackground]="true"
    data-test="internet-summary-register-personalData"
    headingNodeType="h3"
  >
    <p class="mb-0" data-test="internet-summary-customerData-name">{{ fullNameWithTitle() }}</p>
    <p class="mb-0" data-test="internet-summary-customerData-birthdate">{{ birthDate() }}</p>
    <p class="mb-0" data-test="internet-summary-customerData-phone">{{ countryCode() | formatPhoneNumber: telefonNumber() }}</p>
    <p class="mb-0" data-test="internet-summary-customerData-email">{{ email() }}</p>
    @if (idCard() && idCard().art === 'Ausweis') {
      <p class="mb-0">{{ idCard().type }}, {{ idCard().number }}, {{ idCard().issuer }}</p>
    }
  </mwe-basic-card>

  <mwe-basic-card
    [cardTitle]="'summary.personalBilling'"
    [iconClass]="'fa-envelope-open-text'"
    [cardClass]="'mb-4'"
    [hasBackground]="true"
    data-test="internet-summary-register-invoice"
    headingNodeType="h3"
  >
    <mwe-products-summary-invoice-old
      [additionalBulletPoints]="additionalBulletPointsStromGas()"
      [areBankAccountInfoTextsVisible]="areBankAccountInfoTextsVisible()"
      [contactDataEmailAddress]="contactDataEmailAddress()"
      [eRechnungInfo]="eRechnungInfo()"
      [formattedAddress]="formattedAddress()"
      [invoiceInfoAlertMessage]="invoiceInfoAlertMessage()"
      [isPaymentInfoVisible]="isPaymentInfoVisible()"
      [paymentIcon]="paymentIcon()"
      [paymentText]="paymentText()"
      [personalBillingTitle]=""
      [productCategories]="productCategories()"
      billingAddressTitleText="summary.eBillingAddress"
      contactDataEmailAddressLabelClass="text-blue d-inline-block pb-2"
      eBillingLabelClass="text-blue d-inline-block pb-2"
      paymentDataLabelClass="text-blue d-inline-block pb-2"
      shippingEmailTitleText="summary.invoiceAddress.shipping.emailPrefix"
      summaryBillingTitleText="summary.invoiceShipping"
      [headlineNodeType]="headlineService.getHeadline(2)"
    />
  </mwe-basic-card>

  @if (isMobileInternet()) {
    <mwe-basic-card
      [cardTitle]="'summary.internet.routerDeliveryAddress'"
      [iconClass]="'fa-solid fa-person-dolly'"
      [cardClass]="'mb-4'"
      [hasBackground]="true"
      data-test="internet-summary-router-delivery-address"
      headingNodeType="h3"
    >
      <p class="mb-3" translate="summary.internet.routerDeliveryInfo"></p>
      <p class="mb-0">
        <strong>{{ formattedAddressStreet() }}</strong>
      </p>
      <p class="mb-0">
        <strong>{{ formattedPostCode() }}</strong>
      </p>
    </mwe-basic-card>
  }
</div>
